import type { ProductConfig } from '../config/getProductConfig.js';
import type { ITSPayloadBoard } from './ITSPayload.js';
import type { Product } from './Product.js';

export type QuickPick = 'WEIGHTEDQP' | 'MODIFIEDQP' | 'PARTIALQP';
export type RacingBetProperty = 'REPLACEMENT';
export type BoardProperty = QuickPick | RacingBetProperty;

/**
 * Function to check if the provided property is of type QuickPick.
 *
 * @param property The property to check.
 * @returns true if the property is of type QuickPick, false otherwise.
 */
export function isQuickPick(property: BoardProperty): property is QuickPick {
  return ['WEIGHTEDQP', 'MODIFIEDQP', 'PARTIALQP'].includes(property);
}

export type Outcomes = number[];
export type BetEvent = number[][];
export type Bet = number[][][];

export interface IBoard<TBoardSystemType extends string = string> {
  toString: (isCompact?: boolean) => string;
  addOutcomes: (...outcomes: Outcomes | BetEvent) => this;
  setSystemNumber: (systemNumber: number) => this;
  getRowCount: () => number;
  addBoardProperty: (property: BoardProperty) => this;
  outcomes: Readonly<Bet>;
  isQuickPick: boolean;
  boardProperties: readonly BoardProperty[];
  product: Product;
  systemNumber: number;
  productConfig: ProductConfig;

  // Abstract methods
  compose: () => ITSPayloadBoard<object>;
  composeOwnRows: () => ITSPayloadBoard<object>;
  systemType: TBoardSystemType;
}
